export default "__VITE_ASSET__BJs6U0V9__"